import React, { useEffect, useState } from "react";
import ReactStrapTable from "components/reactStrapTable";
import { cellRendererCheck } from "utils/columns";
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  CardHeader,
  Nav,
  NavItem,
  Button,
} from "reactstrap";
import ErrorBoundary from "components/ErrorBoundary";

import ToputilizingMemberSpendDrawer from "pages/ClientDashBoard/Components/GridData/GridReports/TopUtilizingMemberSpendDrawer";
import Drawer from "components/Drawer";
const UtilizingMemberSpend = ({ topUtilizingmember , dateRange, planId, groupId, startDate,endDate,rebatechecked }) => {
  const [summaryData, setSummaryData] = useState([]);
  const [disabledViewButtom, setDisabledViewButtom] = useState(true);
     const [isOpen, setIsOpen] = useState(false);
     useEffect(() => { 
      debugger;
      if (Array.isArray(topUtilizingmember) && topUtilizingmember.length > 0)
         { 
          setDisabledViewButtom(false);
         } else
         { 
          setDisabledViewButtom(true);
         }
         }, [topUtilizingmember]);
  const handleProceed = () => {
    setIsOpen(!isOpen);
  };
  const currencyFormat = (value) => {
    if (!value || isNaN(value)) return "-";
    if (value < 0)
      return (
        <span className="text-danger text-end">
          {"-$" +
            (value * -1).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
        </span>
      );
    else
      return (
        <span className="text-end">
          {"$" + value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
        </span>
      );
  };
  const UtilizingMemberBySpend = [
    {
      dataField: "memberID",
      text: "Member ID",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (topUtilizingmember) =>
        cellRendererCheck(topUtilizingmember.memberID),
    },
    {
      dataField: "totalSpend",
      text: "Total Spend",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (topUtilizingmember) =>
        currencyFormat(topUtilizingmember.totalSpend),
    },
    {
      dataField: "noOfClaims",
      text: "No of Claims",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (topUtilizingmember) =>
        cellRendererCheck(topUtilizingmember.noOfClaims),
    },
  ];
const onHandleIsOpen = (hasRefresh)=> {
      
        if (isBoolean(hasRefresh) && hasRefresh) {
            onClose(true);
        }
        setIsOpen(!isOpen)
      }

  return (
    <ErrorBoundary>
    <Card className="p-3 h-100">
      <CardHeader className="border-0 bg-white px-0 pt-0">
        <Row className="align-items-center">
          <Col>
            <CardTitle className="f-20 font-weight-500">
              Top 10 Utilizing Member By Spend
            </CardTitle>
          </Col>
        </Row>
      </CardHeader>

      <CardBody className="dashboard-chart-body">
        <div
          className={`table-card scroll-table position-relative border-0 rounded pt-0 scroll ${
            topUtilizingmember?.length > 0 ? "fixed-height" : "default"
          }`}
        >
          <ReactStrapTable
            columns={UtilizingMemberBySpend}
            data={topUtilizingmember}
          />
        </div>
        <div className="view-report">
          <Button
            color="primary"
            className="ms-2"
            onClick={handleProceed}
            style={{ float: "right", marginTop: "26px" }}
            disabled={disabledViewButtom}
          >
            View Report
          </Button>
        </div>
      </CardBody>
    </Card>
     <Drawer
                direction='end'
                title='Top 10 Utilizing Member By Spend'
                isOpen={isOpen}
                toggle={handleProceed}
                size="lg"
            >
                    <ToputilizingMemberSpendDrawer  dateRange={dateRange} planId={planId} groupId={groupId} startDate={startDate} endDate={endDate} rebatechecked={rebatechecked} onHandleIsOpen={onHandleIsOpen}  />
            </Drawer> 
    </ErrorBoundary>
  );
};

export default UtilizingMemberSpend;
